import { GenericBackendResponse } from '../genericBackendResponse';

const startKyc = async (token: string): Promise<GenericBackendResponse<{ url: string }>> => {
	const response = await fetch(`${process.env.REACT_APP_BASE_API}/kyc/start`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		}
	});

	if (!response.ok) {
		throw new Error(`KYC start request failed: ${response.status}`);
	}

	return response.json();
};

export default startKyc;
